module.exports = __webpack_public_path__ + "static/media/acorn-background.bb3999a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/img/acorn-background.jpg
// module id = 80
// module chunks = 0